export const devname = {
  device_name: "new_devname",
};

export default devname;
